import { useState } from "react";

import generateOptOutSearchFormPhone from "./generateOptOutSearchFormPhone";

const OptOutSearchFormPhone = ({ handlePhoneOptOut }) => {

  const [brandId, setBrandId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const clearFields = () => {
    setPhoneNumber('')
    setBrandId('');
  } 
  
  return (
    <div
      className="search-form-box opt-out-search"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >

      {generateOptOutSearchFormPhone(
        brandId, setBrandId,
        phoneNumber, setPhoneNumber,
      )}

      <button
        onClick={() => {
            handlePhoneOptOut(phoneNumber, brandId)
          }
        }
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      <button
        onClick={() =>
          clearFields()
        }
        className="subBtn"
      >
        <span>Clear All Fields</span>
      </button>
    </div>
  );
};

export default OptOutSearchFormPhone;